module.exports = __webpack_public_path__ + "img/style_model_preview_681.f32b0a46.jpg";